import type { RecommendationsData, SavedSearchesData } from 'src/queries/types';

export const pluckUserData = (
  data?: RecommendationsData | SavedSearchesData,
) => ({
  emailAddress: data?.viewer?.emailAddress,
  firstName: data?.viewer?.personalDetails?.firstName,
  trackingId: data?.viewer?.trackingId,
  id: data?.viewer?.id,
});

export type UserData = Partial<ReturnType<typeof pluckUserData>>;

export const pluckRecommendedGlobalJobsData = (data?: RecommendationsData) => {
  const recommendedGlobalJobsData =
    data?.viewer?.recommendations?.recommendedGlobalJobs;

  if (recommendedGlobalJobsData) {
    const { solMetadata, globalJobs } = recommendedGlobalJobsData;
    const jobCount = globalJobs && globalJobs.length;

    return {
      solMetadata,
      globalJobs,
      jobCount,
    };
  }

  return {};
};
